module.exports = __webpack_public_path__ + "static/media/dandruff_leaflet@3x.c9f85999.png";